import { CurrencyEnum, LanguageEnum } from "./types.js";
function format(amount, currency, language = navigator && navigator.language.split("-").shift() || LanguageEnum.EN) {
  return new Intl.NumberFormat(language, {
    style: "currency",
    currency: currency || CurrencyEnum.EUR,
    currencyDisplay: "narrowSymbol"
  }).format(amount);
}
export {
  CurrencyEnum,
  LanguageEnum,
  format
};
